class CustomTextarea extends HTMLElement {
  constructor() {
    super();
    this.textArea = null;
    this.counter = null;
    this.maxCount = null;
    this.tooltip = null;

    this.maxCountNumber = null;
    this.mode = null;  // "CHARACTER" OR "WORD" 
    this.errorMessage = null;

    this.CHARACTER_MODE = "CHARACTER"
    this.WORD_MODE = "WORD"

    // Binding 
    this.onChange = this.onChange.bind(this);
    this.getCount = this.getCount.bind(this);
    this.initTextAreaValues = this.initTextAreaValues.bind(this);
}

connectedCallback(){
    // Set elements
    this.textArea = this.querySelector("textarea");
    this.counter = this.querySelector(".custom-textarea-counter");
    this.maxCount = this.querySelector(".custom-textarea-maxcount");
    this.tooltip = this.querySelector(".custom-tooltip-error");
    
    // Set values
    this.maxCountNumber = this.getAttribute("data-max-count") ? parseInt(this.getAttribute("data-max-count")) : 500;
    this.mode = this.getAttribute("data-mode") ?? this.CHARACTER_MODE; 
    this.errorMessage = this.tooltip.textContent.trim();

    if(!this.textArea || !this.counter) return;



    // On change listener
    this.textArea.addEventListener("input", this.onChange)

    this.watchTextareaValue(this.textArea, (newValue) => {
        if(newValue && newValue !== ""){
          // Set initial value
          this.initTextAreaValues();
        }
    })

  }

  watchTextareaValue(textarea, callback) {
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(textarea), 'value');
  
    Object.defineProperty(textarea, 'value', {
      get() {
        return descriptor.get.call(this);
      },
      set(val) {
        descriptor.set.call(this, val);
        callback(val);
      }
    });
  }


  initTextAreaValues(){
    if(this.textArea.value === "") return;
    const value  = this.textArea.value;
    let count = this.getCount(value);
    this.counter.textContent = count;
  }

  getCount(value) {
    if (value === "") return 0;
    
    return this.mode === this.WORD_MODE 
      ? value.split(/\s+/).length 
      : value.length;
  }


  onChange(e){
    const value = this.textArea.value ?? "";
    let count = this.getCount(value);

    this.displayValidation(count);
    this.counter.textContent = count; 
  }

  displayValidation(currentCount){
    if (this.tooltip) {
        let message = this.errorMessage;
        message = message.replace(/{count}/g, currentCount);
        message = message.replace(/{limit}/g, this.maxCountNumber);
        this.tooltip.textContent = message;
    }

    const elements = [this.maxCount, this.counter, this.textArea];
    const hasError = currentCount > this.maxCountNumber;
    elements.forEach(element => {
        element.classList.toggle("max-count-error", hasError);
    });
  }
}

customElements.define('custom-textarea', CustomTextarea);